import packageJson from '../../../package.json';

export const CLIENT_VERSION_HEADER_NAME = 'x-client-version';
export const CLIENT_BUILD_VERSION_HEADER_NAME = 'x-client-build-version';

export const CLIENT_VERSION = String(packageJson.version || '').trim();
export const CLIENT_BUILD_VERSION = String(packageJson.buildVersion ?? '').trim();
